import React from 'react';
import { DialogActions, marginMixin, Paragraph, Popover, Popper, Text, TextButton } from '@zillow/constellation';
import styled from 'styled-components';
import { URLS } from '../../../../../../constants/urls';

interface Props {
  voucherCoversRent?: boolean;
  totalIncomeCoversRent?: boolean;
  className?: string;
}

function VoucherPopover({ voucherCoversRent: voucherCoversRent, totalIncomeCoversRent, className }: Props) {
  const popoverText = voucherCoversRent ? (
    <Paragraph id="voucher-popover-voucher-covers-rent">
      The housing voucher is approved to cover the full monthly rent. However, if the applicant(s) have additional
      income, they may pay a portion of the rent directly.
    </Paragraph>
  ) : totalIncomeCoversRent ? (
    <Paragraph id="voucher-popover-total-income-covers-rent">
      Based on the information provided by the applicant(s), their housing voucher and supplemental income fully cover
      the monthly rent. We recommend verifying this by reviewing the housing voucher and income documentation, as well
      as connecting with the applicant(s) directly.
    </Paragraph>
  ) : (
    <Paragraph id="voucher-popover-rent-not-covered">
      Based on the information provided by the applicant(s), their housing voucher and supplemental income{' '}
      <strong>do not</strong> fully cover the monthly rent. The applicant(s) may have additional income that was not
      specified here. We recommend connecting with the applicants(s) directly.
    </Paragraph>
  );
  const popover = (
    <Popover
      header={<Text fontType="h6">Income and tenant-based vouchers</Text>}
      body={
        <>
          {popoverText}
          <DialogActions>
            <TextButton
              id="learn-more-link"
              as="a"
              target="_blank"
              aria-label="Learn more about vouchers"
              href={URLS.VOUCHER_FAQ_LINK}
            >
              Learn more
            </TextButton>
          </DialogActions>
        </>
      }
    />
  );
  return <Popper className={className} triggered={popover} id="voucher-popover-button" />;
}

export default styled(VoucherPopover)`
  ${marginMixin}
`;
